import { createMigration } from './utils';

const newTextAssetId = '270bd14c-4721-7933-49c9-0a97f3e064e2';

export const migrationTo9_206 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((asset, c) => {
                if (scene.get('sceneCategory') === 'caption' && asset.get('classType') === 'GraphicStyleTextAsset') {
                    map.setIn(['children', c, 'isColorEditable'], false);
                    map.setIn(['children', c, 'id'], newTextAssetId);
                }
            });
        });
    },
});
